app.service('deliveryTimeView', function (front, loading, log, paymentOperator, checkSameDayMessage, console, broker,
	paymentBox, orderUtils, validate, orderConfig, modal, holidayPromotion, unavailableItemsModal, payuPriceLimitMessage) {
	var $self, $form, $deliveryCost, $summaryPrice, $deliveryGroup, $deliveryItem, $customInterval, $deliveryTimeGroup,
		$deliveryTimeList, $deliveryWithOwnPaymentPrice, $hourListElements, $otherDeliveryTime, $deliveryDayMessage;
	var config;
	var selectedInterval = '';
	var transportDateAlreadyChoosen = false;
	let isOneInit = false;

	function sameDayMessage() {
		return checkSameDayMessage.check(config.sameDayMessage, function () {
			config.sameDayMessage = false;
		}, next);
	}
	function next() {
		if (selectedInterval === '0') {
			$deliveryGroup.ignore(true);
		} else {
			$deliveryGroup.ignore(false);
		}
		if (payuPriceLimitMessage.checkStatus()) {
			return;
		}
		if (sameDayMessage()) {
			return;
		}
		if (unavailableItemsModal.checkStatus()) {
			return;
		}
		if (!config.showGiftCardPaymentAmountToCoverBySupplementPayment) {
			$('.js-payment-type').ignore(true);
		} else {
			$('.js-payment-type').ignore(false);
		}
		if ($form.valid()) {
			if ($otherDeliveryTime.length && $otherDeliveryTime.is(':checked')) {
				// tutaj zawsze musimy dopilnować aby poszedł tylko jeden inout "interval"= 0;
				$('input[name=interval]', $form).remove();
				$form.append('<input type="hidden" name="day" value="0"/><input type="hidden" name="interval" value="0"/><input type="hidden" name="otherDeliveryTime" value="true"/>');
			}
			send('NEXT');
		}
	}
	function sendK4HoursShopEvent() {
		var $li = $('.delivery-time-hour-list .group-content.is-visible .delivery-interval');
		var $active = $li.filter('.is-active');
		if ($active.length) {
			let data = {
				id: 'k4_przedziały_czasowe',
				f03: document.location.href,
				f04: textData($active.find('.js-delivery-item')),	// wybrany pprzedział
				f05: config.cartStepOrderInfo.deliveryType,
				f06: "0",
				f07: "0",
				f08: "0",
				f09: "0",
				f10: "0",
				f11: "0",
				f12: "0",
				f13: "0",
				f14: "0"
			}
			function textData($element) {
				return $element.data('ua');
			}
			$li.find('.js-delivery-item').each(function (i, element) {
				var index = 'f' + (i + 6);
				if (i < 9) {
					if (index.length == 2) {
						index = index.substr(0, 1) + '0' + index.substr(1, 1);
					}
					let text = textData($(element));
					if (text) {
						data[index] = text;
					}
				}
			});
			if (data.f04) {
				log.event(data);
			}
		}
	}
	function sendK4DayShopEvent() {
		var $li = $('.grid-box .js-delivery-group, .grid-box .js-delivery-item');

		var $active = $li.filter(':checked');
		if ($active.length) {
			let data = {
				id: 'k4_data_dostawy',
				f03: document.location.href,
				f04: textData($active),
				f05: config.cartStepOrderInfo.deliveryType,
				f06: "0",
				f07: "0",
				f08: "0",
				f09: "0",
				f10: "0",
				f11: "0",
				f12: "0"
			}
			function textData($element) {
				return $element.data('ua');
			}
			$li.each(function (i, element) {

				var index = 'f' + (i + 6);
				if (i < 7) {
					if (index.length == 2) {
						index = index.substr(0, 1) + '0' + index.substr(1, 1);
					}
					let text = textData($(element));
					if (text) {
						data[index] = text;
					}
				}
			});
			if (data.f04) {
				log.event(data);
			}
		}
	}

	function updateConfig(json) {
		config.sameDayMessage = json.sameDayMessage;
		config.payuPriceLimitMessage = json.payuPriceLimitMessage;
		config.showGiftCardPaymentAmountToCoverBySupplementPayment = json.showGiftCardPaymentAmountToCoverBySupplementPayment;
		config.giftCardAmountToCoverBySupplementPayment = json.giftCardAmountToCoverBySupplementPayment;

		let $box = $('#preview-list');
		$box.html(json.previewRight);
		let $box2 = $('#preview-order-steps');
		$box2.html(json.previewLeft);
		$box.attr('wdio-ready', parseInt(Math.random()*1000000000));
		
	}
	function updateSummaryPrice(json) {
		paymentBox.setDefault();
		if (selectedInterval !== '0') {
			$summaryPrice.html(json.mainOrderDeliveryPrice + ' zł');
			if (json.mainOrderDeliveryWithOwnPayment) {
				$deliveryWithOwnPaymentPrice.html(json.mainOrderDeliveryWithOwnPayment + ' zł');
			}
			$self.addClass('show-summary-price');
		}
	}
	function updateGiftCardSummary(json) {
		$self.addClass('show-supplement-payment');
		$('#gift-card-amount-to-cover').html(json.giftCardAmountToCoverBySupplementPayment);
		$('#supplement-payment-amount-to-cover').html(json.giftCardAmountToCoverBySupplementPayment);
		$('#supplement-payment-total-value').html(json.totalWorth);
	}
	function updatePayuPriceLimitMessage(message) {
		payuPriceLimitMessage.open(message);
	}
	function updatePriceSuccess(json) {
		console.log('ZMIANA CZASU/CENY DOSTAWY  - OK');
		$self.removeClass('show-standard-price show-summary-price show-supplement-payment');
		updateConfig(json);
		if (json.payuPriceLimitMessage) {
			updatePayuPriceLimitMessage(json.payuPriceLimitMessage);
		}
		if (json.showGiftCardPaymentAmountToCoverBySupplementPayment) {
			updateGiftCardSummary(json);
		} else {
			updateSummaryPrice(json);
		}
		paymentOperator.change(json.paymentOperator, json.paymentOperatorRegulationUrl);
		$deliveryCost.removeClass('loading');
	}
	function updatePriceError() {
		console.log('ZMIANA CZASU/CENY DOSTAWY  - ERROR');
		$deliveryCost.html('<div class="error">Wystąpił błąd podczas aktualizowania kosztów wysyłki. Prosimy spróbować później</div>');
		$deliveryCost.removeClass('loading');
	}
	function updatePrice(selectedDayIndex = false) {
		$deliveryCost.addClass('loading');
		var ajaxData = {
			cache: false,
			dataType: 'json',
			type: 'POST',
			success: function (json) {
				if (json && json.status) {
					if (json.status === 'OK') {
						//jest ok
					} else if (json.status === 'INVALID_STAGE' && json.message) {
						modal.alert(json.message)
					} else if (json.status === 'ORDER_ABSENCE') {
						loading.redirect("/cart.bhtml");
						return;
					} else if (json.status === 'FORBIDDEN_ACTION') {
						//nie można wykonać akcji
					}
				}
				$.ajax({
					url: '/order-path-preview.ltr',
					dataType: 'json',
					data: {
						refresh: true
					},
					success: function (data) {
						updatePriceSuccess(data);
						broker.trigger('PREVIEW_REFRESH');
					},
					error: function () {
						modal.alert('Błąd odświeżenia stanu zamówienia po zmianie terminu dostawy. Strona zostanie odświeżona.', function () {
							loading.reload();
						});
					}
				});
			},
			error: function () {
				updatePriceError();
			}
		};

		if (selectedDayIndex) {
			ajaxData = $.extend(true, ajaxData, {
				url: '/order-path-time-select-day.ltr',
				data: {
					dayIndex: selectedDayIndex,
					refresh: true
				}
			});
		} else {
			ajaxData = $.extend(true, ajaxData, {
				url: '/order-path-time-select-interval.ltr',
				data: {
					selected_interval: selectedInterval,
					refresh: true
				}
			});
		}

		$.ajax(ajaxData);
	}
	function setCustomInterval() {
		$deliveryGroup.prop('checked', false);
		$deliveryGroup.ignore(true);
		$deliveryTimeList.removeClass('validate-error');
		$form.valid();
	}
	function send(action) {
		sendK4DayShopEvent();
		sendK4HoursShopEvent();
		orderUtils.send(action);
	}
	function back() {
		orderUtils.back();
	}

	function makeHolidayPromotionRequest(transportDateValue) {

		var transportDateData = {
			transportDate: transportDateValue,
			beforeOrderDeliveryTime: false
		};

		holidayPromotion.refresh(transportDateData);
	}

	function refreshHolidayPromotionByTransportDate(transportDate) {
		if (transportDate === undefined) {
			return;
		}
		if (transportDate != '') {
			if (!transportDateAlreadyChoosen) {
				makeHolidayPromotionRequest(transportDate);
				transportDateAlreadyChoosen = true;
			}
		} else {
			if (transportDateAlreadyChoosen) {
				makeHolidayPromotionRequest('');
				transportDateAlreadyChoosen = false;
			}
		}
	}

	function save() {
		if ($deliveryTimeList.length && (selectedInterval == '' || selectedInterval * 1 == 0)) {
			modal.alert("Wybierz termin dostawy");
			return;
		}
		$self.addClass('loading');
		$form.submit();
	}

	function setElements() {
		$self = $('#delivery-time #container');
		$form = $('form:eq(0)', $self);
		$deliveryCost = $('.js-delivery-cost', $self);
		$summaryPrice = $('.js-summary-price span', $self);
		$deliveryWithOwnPaymentPrice = $('.js-delivery-with-own-payment-price span', $self);
		$deliveryGroup = $('.js-delivery-group', $self);
		$deliveryTimeGroup = $('.js-delivery-time-group', $self);
		$deliveryItem = $('.js-delivery-item', $self);
		$deliveryTimeList = $('.js-delivery-time-list', $self);
		$deliveryDayMessage = $('.delivery-day-message', $self);
		$customInterval = $('#custom-interval', $self);
		$hourListElements = $('.group-content', $self);
		$otherDeliveryTime = $('#k5-other-delivery-time', $self);
		config = orderConfig.getData();
	}

	function scrollToFistActiveDate() {
		if (front.getBrakepoint() === "mobile") {
			const $deliverytimeDayList = $('.js-delivery-time-day-list', $self);
			const $firstActiveDateItem = $('.js-delivery-time-group.is-active', $deliverytimeDayList).length ? $('.js-delivery-time-group.is-active', $deliverytimeDayList) : $('.js-delivery-time-group:not(.is-inactive)', $deliverytimeDayList);
			if ($deliverytimeDayList.length && $firstActiveDateItem.length) {
				$deliverytimeDayList.scrollLeft($firstActiveDateItem.offset().left - parseInt($deliverytimeDayList.css('padding-left'), 10));
			}
		};
	};

	function showDeliveryDayMessage(date) {
		$deliveryDayMessage.removeClass('is-visible');
		$deliveryDayMessage.filter('[data-date="' + date + '"]').addClass('is-visible');
	}

	function handleDeliveryTimeGroupClick() {
		const $selectedBox = $(this);
		const position = $selectedBox.index();

		$selectedBox.addClass('is-active')
			.siblings()
			.removeClass('is-active');

		$hourListElements.eq(position)
			.addClass('is-visible')
			.siblings()
			.removeClass('is-visible');

		$hourListElements.closest('.delivery-time-hour-list').addClass('has-selected-hours');

	}
	function otherTime(checked) { 
		if (checked) {
			$('.delivery-time-group.is-active', $self).removeClass('is-active');		//odznaczenie dnia
			$deliveryGroup.removeAttr('checked');										// odznaczenie checkboxa dnia
			selectedInterval = '0';														// ustawiamy interwał na 0;
			$deliveryItem.filter(':checked').prop('checked', false);					// odznaczamy checlbox interwał
			$('#deliveryTimeGroup-error').remove();										// usunięcie belki walidacji nad dniami
			$hourListElements.closest('.delivery-time-hour-list').removeClass('has-selected-hours validate-error');	// odznaczenie godzin
			$hourListElements.closest('.is-visible').removeClass('is-visible');			// odznaczenie godzin
			//$('#interval-error').remove();
			$deliveryTimeList.find('.validate-error').removeClass('validate-error');	// ściągniecie błedu z dni
			$deliveryItem.ignore(true);
			$deliveryGroup.ignore(true);
			updatePrice();
		} else {
			$deliveryItem.ignore(false);
			$deliveryGroup.ignore(false);
		}
	}

	function setEvents() {
		$self.on('click', '.js-delivery-time-group', handleDeliveryTimeGroupClick);
		if ($deliveryTimeList.length && testAB.getVar('delivery_payment')) {
			UA.interaction('TestAB', 'ab_deliverypayment', testAB.getVar('delivery_payment'));
		}
		$self.on('click', '.js-delivery-time-back', function () {
			back();
		});
		$otherDeliveryTime.click(function () {
			otherTime($(this).is(':checked'));
		});

		$('.js-save-delivery-time', $self).click(function () {
			save();
		});
		$('.js-save-payu-delivery-time', $self).click(function () {
			if ($form.valid()) {
				loading.start();
				$form.submit();
			}
		});

		$deliveryGroup.click(function () {
			var $currentDeliveryTimeGroup = $(this).closest('.js-delivery-time-group');
			const position = $currentDeliveryTimeGroup.index();
			const selectedDayIndex = $(this).data('index') / 1 - 1; // pobierany index jest iteracją dla listy z forEach, więc potrzebne jest jego pomniejszenie
			var selectFirstInterval = $(this).data('select-interval');
			$customInterval.prop('checked', false);
			$otherDeliveryTime.prop('checked', false);
			$deliveryItem.filter(':checked').prop('checked', false);
			if ($currentDeliveryTimeGroup.length) {
				$.scrollTo($currentDeliveryTimeGroup);
			}
			if (selectFirstInterval) {
				let $inputs = $hourListElements.eq(position).find('.js-delivery-item');
				let $input = $inputs.eq(0);
				if ($inputs.length == 1) {
					$input.click();
				} else {
					updatePrice(selectedDayIndex);
				}
			} else if ($hourListElements.eq(position).find('.js-delivery-item:checked').length == 0) {
				selectedInterval = '0';
				$deliveryItem.filter(':checked').prop('checked', false);
				$self.removeClass('show-summary-price show-gift-card-summary');
				updatePrice(selectedDayIndex);
			}
			var statusDate = $(this).data("date");
			if (statusDate) {
				makeHolidayPromotionRequest(statusDate);
			}
		});
		$deliveryItem.on('click', function () {
			$(this)
				.parent()
				.addClass('is-active')
				.siblings()
				.removeClass('is-active');
			selectedInterval = $(this).val();
			$(this).closest('.delivery-time-hour-list').removeClass('validate-error');
			$(this).closest('form').validate().element($(this));
			$otherDeliveryTime.prop('checked', false);
			const thisDate = $(this).data('date'); //wybrany dzień jest interwałem godzinowym
			if (thisDate) {
				showDeliveryDayMessage(thisDate);
			}
			updatePrice();
			var statusDate = $(this).data("intervalholidaystatus");
			if (statusDate) {
				makeHolidayPromotionRequest(statusDate);
			}
		});
		$customInterval.on('click', function () {
			setCustomInterval();
		});
		validate.task('deliveryTime');
		if(!isOneInit){
			isOneInit = true;
			$('body').on('click', '.js-delivery-time-next', function () {
				next();
			});
			broker.on('ORDER-NEXT-STEP', function () {
				if(config.pageType == 'delivery-time'){
					next();
				}
			});
		}
	}

	function checkSelectedDeliveryTime() {
		if (config.deliveryTimeType === 'calendar') {
			var checked = $deliveryItem.filter(':checked');

			if (checked.length) {
				selectedInterval = checked.val();

				var $parentGroup = checked.closest('.group-content');

				if ($parentGroup.length) {
					$parentGroup.addClass('is-visible');
					$.scrollTo($parentGroup);
				}

				updatePrice();
			}
		} else {
			$self.addClass('show-standard-price');
		}
	}

	function checkSplitPaymentMessage() {
		if ($('.js-split-payment-message').length) {
			modal.generate({
				content: $('.js-split-payment-message').html(),
				buttons: [
					{
						text: 'Ok',
						cssClass: 'btn-primary js-close-modal'
					}
				]
			});
		}
	}

	function init() {
		setElements();
		setEvents();
		scrollToFistActiveDate();
		refreshHolidayPromotionByTransportDate(config.refreshHolidayPromotionByTransportDate);
		checkSplitPaymentMessage();
		sameDayMessage();
		checkSelectedDeliveryTime();
		unavailableItemsModal.init();
		payuPriceLimitMessage.init();
		if (config.paymentCode == 16) {
			paymentBox.init(updatePriceSuccess);
			paymentOperator.init()
		}
	}

	return {
		init
	};
});
